<script setup>
import BlogAuthor from '~/components/blocks/two-six/blog/blog-author.vue';
import BlogThreeUp from '~/components/blocks/two-six/blog/blog-three-up.vue';
import Cta from '~/components/blocks/two-six/cta.vue';

const { page } = defineProps({
    page: {
        type: Object,
        required: true,
    },
});

const button = {
    label: 'All Blog Posts',
    url: '/blog'
}

const cta_image = {
    src: 'https://cdn.builder.io/api/v1/image/assets%2Fd09cfff8ac614d8a86e457a0274fa171%2F1363d26f8823416c906a1354d404b6be',
    altText: 'UNBOUND 2026 attendees'
}

const cta_button = {
    url: '/register',
    label: 'Register for UNBOUND 2026'
}

</script>
<template>
    <div class="blog-footer">
        <div class="root-container">
            <BlogAuthor :page="page" />
        </div>
        <globalBackToTop></globalBackToTop>
        <div class="related-posts-footer bg-white">
            <BlogThreeUp v-if="page" :page="page" headline="Related Blog Posts" :button=button />
            <Cta
                headline="Be There at UNBOUND 2026"
                copy="Boston. September 16–18. Three days designed to help you move beyond outdated playbooks. Join leaders across marketing, sales, service, and operations for the insights, connections, and clarity that turn change into action and drive unified, measurable growth across your team. Break beyond the limits that defined yesterday. Be unstoppable."
                :image="cta_image"
                :button="cta_button" />
        </div>
    </div>
</template>

<style>
.blog-footer .blog-author {
    margin-bottom: 4.5625rem;
}
.blog-footer .back-to-top {
    margin-bottom: 2.3125rem;
}
</style>
